module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_pp1_9016.9355b82c.png";